import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
 // Assuming you have a CSS file for the header

const Header = () => {
  return (
    <nav className="header">
      <ul className='nav'>
        <li>
          <Link to="/">About</Link>
        </li>
        <li>
          <Link to="/projects">Projects</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
